module.exports = __webpack_public_path__ + "img/multiple_benchmark_graph.e048b418.png";